// このファイルは scripts/renewal/gen_site.py でモックアップから生成した。
// 文言・構成を直すときは、このファイルを直接編集してよい（再生成はしない）。
import { Link } from "react-router-dom";
import ContactBand from "../../ContactBand";

export default function CasePizzaday() {
  return (
    <main>
      <section className="page-hero ground cd-hero" data-en="WORKS">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">トップ</Link>
            <Link to="/cases">実績・事例</Link>
            <span>PIZZA DAY</span>
          </nav>
          <div className="case-tags cd-tags">
            <span>アパレル・ファッション</span>
            <span>ブロックチェーン事業開発</span>
          </div>
          <h1 className="cd-title">
            サステナブルアパレルブランドに、Web3の顧客体験を実装する。PIZZA DAY
            — NFT × 暗号資産決済 × 地域創生
          </h1>
          <p className="cd-client">株式会社Spicelink</p>
          <div className="cd-img">
            <img
              src="https://stg.leaps-inc.com/cms-admin/wp-content/uploads/2026/03/main-11-884x600-1.jpg"
              alt=""
            />
          </div>
          <div className="cd-summary">
            <div>
              <span>課題</span>
              <p>
                NFT・暗号資産決済・ECを統合して実装できる技術パートナーがいなかった。
              </p>
            </div>
            <div>
              <span>解決策</span>
              <p>LEAPSは企画・開発・実装の全フェーズを担当。</p>
            </div>
            <div>
              <span>成果</span>
              <p>
                NFT・暗号資産決済・ECを統合したWeb3ブランド体験をフルスタックで実装。
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="cd-body container">
          <section className="cd-sec">
            <h2>プロジェクト概要</h2>
            <p>
              PIZZA
              DAYは、「ウール製品を肥料化し、土へと還す循環モデル」を軸に展開するサステナブルアパレルブランドです。LEAPSは、Polygon上でのNFTを活用したロイヤリティプログラムの設計・開発、暗号資産による決済機能の実装、ShopifyをベースにしたECサイトの構築を一気通貫で担いました。
            </p>
            <p>
              単なるECサイトの構築にとどまらず、NFTホルダー向けの特典設計やトークンゲートの実装など、ブロックチェーンを活用した新しいブランド体験の仕組みをゼロから設計しました。
            </p>
          </section>
          <section className="cd-sec">
            <h2>解決すべき課題</h2>
            <p>
              ブランドとしてWeb3・ブロックチェーンを活用した顧客体験を実現したいというビジョンはあったものの、NFT・決済・ECを統合した形で実装できる技術パートナーが存在しないことが事業化の壁となっていました。
            </p>
            <h4 className="cd-sub">事業化における課題</h4>
            <ul className="cd-list">
              <li>
                NFT・暗号資産決済・ECを統合して実装できる技術パートナーがいなかった
              </li>
              <li>
                ブロックチェーンを活用したロイヤリティプログラムの具体的な設計・企画ができていなかった
              </li>
            </ul>
            <h4 className="cd-sub">顧客体験における課題</h4>
            <ul className="cd-list">
              <li>
                従来のポイント・会員プログラムでは、コアファンへの特別体験や希少性の演出に限界があった
              </li>
              <li>
                暗号資産ユーザー・Web3コミュニティへのリーチ手段がなく、新規顧客層の開拓が進んでいなかった
              </li>
            </ul>
          </section>
          <section className="cd-sec">
            <h2>LEAPSが提供したソリューション</h2>
            <p>
              LEAPSは企画・開発・実装の全フェーズを担当。NFTの設計からShopifyとのシステム連携、暗号資産決済の組み込みまで、ブランドのビジョンに基づくプロダクトとして具現化しました。
            </p>
            <div className="cd-point">
              <span className="cd-num">01</span>
              <div>
                <p className="cd-cat">NFT開発</p>
                <h3 className="cd-ptitle">
                  Polygon上でのロイヤリティプログラム
                </h3>
                <p>
                  NFTホルダー向けの特典・限定コンテンツへのアクセス権を設計。トークンゲートによる会員体験の差別化を実装しました。
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">02</span>
              <div>
                <p className="cd-cat">決済実装</p>
                <h3 className="cd-ptitle">暗号資産決済の統合</h3>
                <p>
                  ETHなどの暗号資産による商品購入を可能にする決済基盤をShopifyと連携して構築。Web3ユーザーがシームレスに購入できる体験を実現しました。
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">03</span>
              <div>
                <p className="cd-cat">EC構築</p>
                <h3 className="cd-ptitle">ShopifyベースのECサイト開発</h3>
                <p>
                  ブランドの世界観に合わせたShopifyストアを構築。NFT連携・暗号資産決済・通常のEC機能を統合した、一体型の購買体験を設計しました。
                </p>
              </div>
            </div>
          </section>
          <section className="cd-sec">
            <h2>那須塩原市との地域連携「ウールとワインと那須塩原のWA！」</h2>
            <p>
              PIZZA
              DAYと那須塩原市が共創した、ウール肥料でつくるサーキュラーワインのプロジェクト。酒類販売の法的障壁をNFTによる「ワイン引換券」という仕組みで解消し、購入者が翌夏にワインと交換できるリアルワールドアセット型メンバーシップNFTとして実装しました。
            </p>
            <div className="cd-point">
              <span className="cd-num">01</span>
              <div>
                <p className="cd-cat">NFT引換券スキーム</p>
                <p>
                  通信販売酒類免許の壁をNFTで回避。ビール券方式でワインを届ける仕組みを設計
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">02</span>
              <div>
                <p className="cd-cat">MPCウォレット導入</p>
                <p>
                  秘密鍵不要・メールアドレスのみでNFT保有。非Web3ユーザーへの普及を実現
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">03</span>
              <div>
                <p className="cd-cat">参加型体験の設計</p>
                <p>
                  収穫イベント・オンライン配信など、ワインが育つ過程をホルダーが体験できる仕組みを構築
                </p>
              </div>
            </div>
          </section>
          <section className="cd-sec">
            <h2>成果と意義</h2>
            <p>
              NFT・暗号資産決済・ECを統合したWeb3ブランド体験をフルスタックで実装。さらに法規制の壁をNFTで突破するという、技術と事業設計を掛け合わせた事例となりました。
            </p>
            <div className="cd-point">
              <span className="cd-num">01</span>
              <div>
                <p className="cd-cat">EC × ブロックチェーンの統合</p>
                <p>Shopify・NFT・暗号資産決済を一体化したブランド体験を構築</p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">02</span>
              <div>
                <p className="cd-cat">法的障壁をNFTで突破</p>
                <p>酒類販売規制の課題をNFT引換券スキームで解決し事業化を実現</p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">03</span>
              <div>
                <p className="cd-cat">地域創生への展開</p>
                <p>那須塩原市との連携でWeb3を地方創生に活用した先進事例に</p>
              </div>
            </div>
          </section>
        </div>
      </section>
      <section className="cd-sec">
        <h2>那須塩原市との地域連携「ウールとワインと那須塩原のWA！」</h2>
        <p>
          PIZZA
          DAYと那須塩原市が共創した、ウール肥料でつくるサーキュラーワインのプロジェクト。酒類販売の法的障壁をNFTによる「ワイン引換券」という仕組みで解消し、購入者が翌夏にワインと交換できるリアルワールドアセット型メンバーシップNFTとして実装しました。
        </p>
        <div className="cd-point">
          <span className="cd-num">01</span>
          <p>
            NFT引換券スキーム通信販売酒類免許の壁をNFTで回避。ビール券方式でワインを届ける仕組みを設計
          </p>
        </div>
        <div className="cd-point">
          <span className="cd-num">02</span>
          <p>
            MPCウォレット導入秘密鍵不要・メールアドレスのみでNFT保有。非Web3ユーザーへの普及を実現
          </p>
        </div>
        <div className="cd-point">
          <span className="cd-num">03</span>
          <p>
            参加型体験の設計収穫イベント・オンライン配信など、ワインが育つ過程をホルダーが体験できる仕組みを構築
          </p>
        </div>
      </section>
      <section className="cd-sec">
        <h2>成果と意義</h2>
        <p>
          NFT・暗号資産決済・ECを統合したWeb3ブランド体験をフルスタックで実装。さらに法規制の壁をNFTで突破するという、技術と事業設計を掛け合わせた事例となりました。
        </p>
        <div className="cd-point">
          <span className="cd-num">01</span>
          <p>
            EC ×
            ブロックチェーンの統合Shopify・NFT・暗号資産決済を一体化したブランド体験を構築
          </p>
        </div>
        <div className="cd-point">
          <span className="cd-num">02</span>
          <p>
            法的障壁をNFTで突破酒類販売規制の課題をNFT引換券スキームで解決し事業化を実現
          </p>
        </div>
        <div className="cd-point">
          <span className="cd-num">03</span>
          <p>
            地域創生への展開那須塩原市との連携でWeb3を地方創生に活用した先進事例に
          </p>
        </div>
      </section>
      <section className="section ground">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            ほかの事例<strong>Other Works</strong>
          </h2>
          <div className="case-grid">
            <Link className="case-card" to="/cases/anybound">
              <div className="case-img">
                <img
                  src="https://stg.leaps-inc.com/cms-admin/wp-content/uploads/2026/03/FV-1024x610.png"
                  alt=""
                />
              </div>
              <p className="case-meta">株式会社JTB</p>
              <h3>
                希少な旅行体験をブロックチェーンで流通させる共創プロジェクト「anyBOUND」
              </h3>
              <div className="case-tags">
                <span>エンタープライズ</span>
                <span>ブロックチェーン事業開発</span>
                <span>共創プロジェクト</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/kanda-curry">
              <div className="case-img is-cover">
                <span className="cover-en">NFT STAMP RALLY</span>
                <span className="cover-ja">スタンプラリー × NFT</span>
              </div>
              <p className="case-meta">広告代理店</p>
              <h3>
                スタンプラリーの思い出をNFTで残す「神田カレーグランプリ2025」
              </h3>
              <div className="case-tags">
                <span>イベント・観光</span>
                <span>ブロックチェーン事業開発</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/premience">
              <div className="case-img">
                <img src="/assets/images/case-premience.jpg" alt="" />
              </div>
              <p className="case-meta">株式会社JTB</p>
              <h3>
                JTBのラグジュアリー体験ブランド「プレミエンス」のロゴ制作とサイトリニューアル
              </h3>
              <div className="case-tags">
                <span>旅行・観光</span>
                <span>ブランディング・Web制作</span>
              </div>
            </Link>
          </div>
          <div className="more">
            <Link to="/cases">実績一覧を見る →</Link>
          </div>
        </div>
      </section>
      <ContactBand ground={false} />
    </main>
  );
}
